export default "__VITE_ASSET__DqNwsK6k__"